import React from 'react';
import { Container, Stack, useTheme } from '@mui/system';
import { Box, Typography } from '@mui/material';

const hotkeys = [
  {
    question: `Why should I use hotkeys?`,
    answer: `Typing is obviously a HUGE element to PAR, so you should optimize every bit of it as possible. You will lose precious seoncds anytime you have to reach for the mouse or touchpad.`,
  },
  {
    question: `Clearing your input/text box quickly`,
    answer: `For Windows: Ctrl + BACKSPACE
    For Mac: Cmd + DELETE
    
    You can also Ctrl/Cmd + A to highlight the entire text then click DELETE`,
  },
  {
    question: `Place your cursor at the beginning of the word`,
    answer: `For Windows: Ctrl + LEFT_ARROW
    For Mac: Cmd + LEFT_ARROW
    
    You can also use the HOME button if you have one on your keyboard.
    `,
  },
];

export const Tips = () => {
  return (
    <Container sx={{ paddingBottom: 10 }}>
      <Typography variant="h4" textAlign={'center'} mb={4}>
        Tips
      </Typography>
      <Typography variant="h5" fontWeight={600} mb={2} color="secondary.main">
        Hotkeys
      </Typography>
      {hotkeys.map((o) => (
        <>
          <Stack direction={'row'} spacing={1} mt={2}>
            <Typography color="success.main">Q:</Typography>
            <Typography variant="body1">{o.question}</Typography>
          </Stack>
          <Stack direction={'row'} spacing={1} mt={1} mb={1}>
            <Typography color="ranked.main">A:</Typography>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
              {o.answer}
            </Typography>
          </Stack>
        </>
      ))}
    </Container>
  );
};
